export default __webpack_public_path__ + "static/media/A7537D81-57CD-4150-933D-6EED0A914DC2_1_105_c.586ed641.jpeg";